"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const renderDownloadIcon = function (color) {
  let size = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "24";
  return /*#__PURE__*/_react.default.createElement("div", {
    className: "download-icon"
  }, /*#__PURE__*/_react.default.createElement("svg", {
    width: size,
    height: size,
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 20 20"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/_react.default.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/_react.default.createElement("path", {
    d: "M9.29,15.71a1,1,0,0,0,1.42,0l4.95-5a1,1,0,0,0-1.42-1.42L11,12.59V1A1,1,0,0,0,9,1V12.59L5.76,9.34a1,1,0,0,0-1.42,0,1,1,0,0,0,0,1.42Z",
    fill: color
  }), /*#__PURE__*/_react.default.createElement("path", {
    d: "M19,18H1a1,1,0,0,0,0,2H19a1,1,0,0,0,0-2Z",
    fill: color
  })))));
};
var _default = renderDownloadIcon;
exports.default = _default;